import React from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import './PolicyPage.css';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <PageMeta
        title="Privacy Policy"
        description="Fmultratech Farms Privacy Policy. How we collect, use, and protect your personal information."
      />
      <div className="policy-page">
        <div className="policy-hero">
          <h1>Privacy Policy</h1>
          <p>Fmultratech Farms</p>
        </div>
        <div className="policy-content">
          <div className="policy-container">
            <section className="policy-section">
              <h2>1. Introduction</h2>
              <p>
                Fmultratech Farms (“Company”, “we”, “us”, or “our”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and protect personal data when you access or use our platform, website, or services.
              </p>
              <p>
                By using our services, you agree to the collection and use of information in accordance with this Privacy Policy.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Information We Collect</h2>
              <p>
                We collect limited personal information necessary to provide and improve our services. This may include:
              </p>
              <h3>2.1 Personal Information Provided by Users</h3>
              <ul>
                <li>Full name</li>
                <li>Phone number</li>
                <li>Email address</li>
                <li>Delivery address or location information</li>
                <li>Account login details</li>
                <li>Order and transaction information</li>
              </ul>
              <h3>2.2 Automatically Collected Information</h3>
              <ul>
                <li>Device information</li>
                <li>IP address</li>
                <li>Usage data and interaction with the platform</li>
                <li>Log data necessary for system performance and security</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. How We Use Your Information</h2>
              <p>
                We collect and process personal data primarily to:
              </p>
              <ul>
                <li>Provide and manage our services</li>
                <li>Process and fulfill customer orders</li>
                <li>Communicate with users regarding orders, support, or updates</li>
                <li>Improve platform performance and user experience</li>
                <li>Maintain security and prevent fraud</li>
                <li>Comply with legal obligations where applicable</li>
              </ul>
              <p>
                We only collect data necessary to better serve customers and operate our platform effectively.
              </p>
            </section>

            <section className="policy-section">
              <h2>4. Data Sharing and Disclosure</h2>
              <p>
                Fmultratech Farms does not sell or trade user personal data.
              </p>
              <p>
                We may share limited information with third parties only when necessary, including:
              </p>
              <ul>
                <li>Production partners or fulfillment providers to complete orders</li>
                <li>Delivery or logistics providers</li>
                <li>Payment processing services</li>
                <li>Technical service providers assisting with system operations or improvement</li>
                <li>Legal authorities when required by law or regulation</li>
              </ul>
              <p>
                All such sharing is limited to what is necessary to provide or improve services.
              </p>
            </section>

            <section className="policy-section">
              <h2>5. Data Storage and Security</h2>
              <p>
                We implement reasonable administrative, technical, and organizational measures to protect personal information from unauthorized access, alteration, disclosure, or destruction.
              </p>
              <p>
                While we strive to protect user data, no method of electronic storage or transmission is completely secure, and absolute security cannot be guaranteed.
              </p>
            </section>

            <section className="policy-section">
              <h2>6. Data Retention</h2>
              <p>
                Personal information is retained only for as long as necessary to:
              </p>
              <ul>
                <li>Provide services to users</li>
                <li>Maintain operational records</li>
                <li>Comply with legal or regulatory requirements</li>
              </ul>
              <p>
                After this period, data may be deleted or anonymized.
              </p>
            </section>

            <section className="policy-section">
              <h2>7. User Rights</h2>
              <p>
                Users may request to:
              </p>
              <ul>
                <li>Access their personal data</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of their account or personal data (subject to legal or operational requirements)</li>
              </ul>
              <p>
                Requests can be submitted through official support channels.
              </p>
            </section>

            <section className="policy-section">
              <h2>8. Third-Party Services</h2>
              <p>
                Our platform may use third-party tools or services to improve functionality. These providers may process limited data strictly for operational purposes.
              </p>
              <p>
                We are not responsible for the privacy practices of external websites or services not operated by Fmultratech Farms.
              </p>
            </section>

            <section className="policy-section">
              <h2>9. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Continued use of our platform after updates constitutes acceptance of the revised policy.
              </p>
            </section>

            <section className="policy-section">
              <h2>10. Contact Information</h2>
              <p>
                If you have any questions or requests regarding this Privacy Policy, please contact us through the official communication channels provided on the Fmultratech Farms platform.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
